import { DateUtils } from '../utils/date.utils';

export const bookingCodeTemplate = (payload?: any): string => {
  return `BK-${DateUtils.todayString()}`;
};
